import { useRef, useState } from 'react';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { IServicesProps } from './Services';

export const useServices = ({ services }: IServicesProps) => {
  const navElementRef = useRef<HTMLUListElement>(null);
  const servicesRef = useRef<HTMLDivElement>(null);
  const navScrollRef = useRef<any>();

  const [activeService, setActiveService] = useState(-1);
  const windowSize = useWindowSize();
  const servicesTitles = services.map((service) => service.title);

  const onVisibleSlideChange = (isVisible: boolean, slide: number) => {
    if (isVisible && activeService !== slide) {
      setActiveService(slide);
      if (navScrollRef.current) {
        clearTimeout(navScrollRef.current);
      }
      navScrollRef.current = setTimeout(() => {
        if (windowSize.width && windowSize.width < 800) {
          const currentSlide = navElementRef.current?.children[slide];
          const componentLeft = currentSlide?.getBoundingClientRect().left || 0;
          const l = componentLeft + (navElementRef.current as any).scrollLeft;
          navElementRef.current?.scrollTo({ left: l, behavior: 'smooth' });
        }
      }, 300);
    }
  };

  const clickNavigationItemHandle = (slide: number) => {
    const currentSlide = servicesRef.current?.children[slide];
    const yOffset = -130;

    const componentTop = currentSlide?.getBoundingClientRect().top || 0;
    const y = componentTop + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return {
    navElementRef,
    servicesTitles,
    activeService,
    clickNavigationItemHandle,
    onVisibleSlideChange,
    windowSize,
    servicesRef,
  };
};
